import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/cog.svg'


const _hoisted_1 = { id: "footer" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div id=\"footer-attribution\"><span>Created by <a href=\"https://plagiatus.net\" target=\"_blank\" rel=\"noopener noreferrer\">Plagiatus</a></span><span>Design by <a href=\"https://twitter.com/TWmrjvs\" target=\"_blank\" rel=\"noopener noreferrer\">MrJVS</a></span><span>Minecraft Avatars provided by <a href=\"https://crafatar.com/\" target=\"_blank\" rel=\"noopener noreferrer\">Crafatar</a></span></div><div id=\"footer-copyright\" class=\"italic\"><span>© Realmshub.com 2020-2023</span></div>", 2)
const _hoisted_4 = { id: "footer-settings" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Settings", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_settings = _resolveComponent("settings")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        id: "footer-settings-inner",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSettings && _ctx.toggleSettings(...args)))
      }, [
        _hoisted_5,
        _createElementVNode("img", {
          src: _imports_0,
          alt: "settings",
          id: "settings-img",
          class: _normalizeClass({rotated: _ctx.settingsVisible})
        }, null, 2)
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.settingsVisible)
            ? (_openBlock(), _createBlock(_component_settings, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}